import type { PaymentTaxesTranslations } from "../interfaces/paymentTaxes";

export const paymentTaxesTranslations: PaymentTaxesTranslations = {
  // Page
  page_title: "Impuestos",
  page_subtitle:
    "IVA, 4x1000 o cualquier impuesto por país, corredor por corredor: sobre la comisión o sobre el monto, quién lo paga y qué organizaciones pagan distinto",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar impuestos",
  new_tax_button: "Nuevo impuesto",
  why_banner:
    "Los impuestos que paga el cliente se suman a lo que se le cobra, como la comisión; los que asume Coloca no cambian sus montos. Las cotizaciones y los lotes ya validados conservan el impuesto con el que se calcularon.",
  truncated_notice: "Hay más versiones de las cargadas; lo que se muestra puede no estar completo.",
  error_load: "No pudimos cargar los impuestos",
  error_load_detail: "Revisa tu conexión e intenta de nuevo.",
  error_retry: "Reintentar",
  empty_title: "Todavía no hay impuestos",
  empty_description: "Crea el primero, por ejemplo el IVA sobre la comisión o el 4x1000 sobre el monto.",
  empty_org_title: "Sin impuestos para esta organización",
  empty_org_description: "No hay impuestos generales ni propios que apliquen a esta organización.",

  // Scope selector
  scope_label: "Alcance",
  scope_placeholder: "Buscar por nombre, correo o ID…",
  scope_loading: "Cargando organizaciones…",
  scope_empty: "No se encontraron organizaciones.",
  scope_searching: "Buscando organizaciones…",
  scope_search_error: "No pudimos completar la búsqueda; se muestran las organizaciones ya cargadas.",
  scope_global_option: "General (todas las organizaciones)",
  scope_global_hint: "Impuestos generales: los que paga cualquier organización sin tarifa propia.",
  scope_org_hint:
    "Lo que paga esta organización. Los cambios aquí crean su tarifa propia, que gana sobre la general.",
  scope_catalog_error:
    "No pudimos cargar el catálogo de organizaciones; algunas pueden mostrar su ID en lugar del nombre.",
  scope_catalog_truncated: "Hay más organizaciones de las listadas; escribe para buscarlas todas.",

  // Rows
  base_commission: "Sobre la comisión",
  base_gross: "Sobre el monto",
  bearer_client: "Lo paga el cliente",
  bearer_coloca: "Lo asume Coloca",
  bearer_client_hint: "Se suma a lo que paga el cliente, igual que la comisión.",
  bearer_coloca_hint: "El cliente no ve ningún cambio; Coloca lo registra como gasto.",
  where_all: "Cobros y envíos",
  where_payin: "Solo cobros",
  where_payout: "Solo envíos",
  where_any_rail: "todos los rieles",
  exempt: "Exenta",
  source_general: "General",
  source_own: "Propia",
  inherited_from: "Por su tarifa propia de {{where}}",
  exceptions_count: "Excepciones: {{count}}",
  scheduled: "Cambio programado",
  since: "Desde {{date}}",
  example_commission: "Comisión {{amount}}",
  example_gross: "Monto {{amount}}",
  example_tax_fallback: "Impuesto",
  actions_aria: "Acciones de {{name}}",
  action_change: "Cambiar tarifa",
  action_change_special: "Cambiar tarifa propia",
  action_special: "Dar tarifa propia",
  action_special_here: "Dar tarifa propia solo aquí",
  action_exempt: "Exonerar",
  action_back_general: "Volver a la general",
  action_history: "Ver historial",

  // Dialog
  dialog_title_new: "Nuevo impuesto",
  dialog_title_change: "Cambiar {{name}}",
  dialog_title_special: "Tarifa propia de {{name}}",
  dialog_scope_general: "Aplica a todas las organizaciones sin tarifa propia.",
  dialog_scope_org: "Solo para {{org}}.",
  field_country: "País",
  field_code: "Código",
  field_code_hint: "De 2 a 8 letras o números, por ejemplo IVA o GMF. Agrupa las versiones del impuesto.",
  field_name: "Nombre",
  field_name_hint: "Lo que ven clientes y operaciones, por ejemplo IVA o 4x1000.",
  field_base: "Se calcula",
  field_base_locked: "La base de un impuesto no cambia entre versiones.",
  field_rate: "Tarifa",
  field_rate_hint: "Porcentaje de la comisión de Coloca. 0 deja exento el alcance.",
  field_rate_gross_hint:
    "Porcentaje del monto: en cobros, lo que envía el pagador; en envíos, lo que recibe la persona. Máximo 10 %.",
  field_bearer: "Quién lo paga",
  field_direction: "Aplica a",
  field_rail: "Riel",
  field_rail_any: "Cualquier riel",
  eff_now_label: "Rige desde ahora",
  eff_date_label: "Desde el día",
  eff_time_label: "Hora",
  reason_label: "Motivo",
  reason_placeholder: "Por ejemplo: resolución de la DIAN, acuerdo con el cliente…",
  reason_hint: "Interno: queda en el historial y en la alerta del cambio.",
  review_title: "Revisa el cambio",
  review_before: "Hoy",
  review_after: "Con el cambio",
  review_none: "Sin impuesto",
  review_affects:
    "Afecta a todas las organizaciones sin tarifa propia de {{name}} en {{country}}, desde la fecha indicada.",
  review_ack: "Entiendo que esto cambia lo que pagan los clientes desde esa fecha.",
  button_cancel: "Cancelar",
  button_back: "Atrás",
  button_review: "Revisar",
  button_save: "Guardar",
  validation_code: "Usa de 2 a 8 letras o números, sin espacios.",
  validation_name: "Escribe un nombre de hasta 64 caracteres.",
  validation_rate: "Escribe un porcentaje entre 0 y 100, con hasta 4 decimales.",
  validation_rate_gross: "Sobre el monto total el máximo es 10 %.",
  validation_valid_from: "Elige desde qué día rige.",
  validation_reason: "Escribe el motivo del cambio.",
  validation_ack: "Confirma que revisaste el cambio.",

  // Exemptions
  exempt_title: "Exonerar de {{name}}",
  exempt_description:
    "{{org}} deja de pagar {{name}} en {{where}} desde ahora. Las operaciones ya hechas y las cotizaciones vigentes no cambian.",
  exempt_confirm: "Exonerar",
  back_general_title: "Volver a la tarifa general de {{name}}",
  back_general_description:
    "Se eliminan las versiones propias de {{org}} para {{name}} en {{where}}; desde ahora paga la tarifa general.",
  back_general_confirm: "Volver a la general",
  back_general_affects: "Esta regla también aplica en: {{rows}}. Todas vuelven a la tarifa general.",

  // History
  history_title: "Historial de {{name}}",
  history_description: "Cada versión de este alcance, de la más reciente a la más antigua.",
  history_scope_general: "Tarifa general · {{where}}. La paga toda organización sin tarifa propia.",
  history_scope_own: "Tarifa propia de {{org}} · {{where}}.",
  history_scope_covers: "Esta regla aplica en: {{rows}}. Eliminar una versión las cambia todas.",
  history_read_only_general: "Solo lectura: la tarifa general se corrige sin organización elegida.",
  history_read_only_inherited: "Solo lectura: esta regla se corrige desde su propia fila.",
  history_version: "Versión {{version}}",
  history_in_force: "Vigente",
  history_scheduled: "Programada",
  history_superseded: "Reemplazada",
  history_reason_none: "Sin motivo",
  history_delete: "Corregir: eliminar esta versión",
  history_delete_description:
    "La versión anterior vuelve a regir. Para dejar de cobrar el impuesto, guarda una versión en 0 %.",
  history_delete_confirm: "Eliminar versión",

  // Feedback
  toast_saved: "{{name}} guardado",
  toast_deleted: "Versión eliminada",
  toast_exempted: "{{org}} quedó exenta de {{name}}",
  toast_back_general: "{{org}} vuelve a la tarifa general de {{name}}",
  error_save: "No pudimos guardar el impuesto.",
  error_delete: "No pudimos eliminar la versión.",
  error_no_write_permission: "No tienes permiso para cambiar impuestos.",

  // Corridors view
  tab_corridors: "Corredores",
  tab_history: "Historial de cambios",
  tab_rules: "Reglas",
  tab_intro_corridors:
    "Cada corredor con los impuestos que cobra hoy, calculados sobre el monto de ejemplo. Edítalos desde su fila.",
  tab_intro_history:
    "Cada cambio de un impuesto, el más reciente primero: quién lo hizo, qué había antes y por qué.",
  tab_intro_rules:
    "Las reglas de cada país con sus versiones. Aquí se crea un impuesto nuevo y se corrige una versión.",
  guide_title: "Cómo funcionan los impuestos",
  guide_base_title: "Sobre qué se calcula",
  guide_base_body:
    "Sobre la comisión de Coloca (el IVA) o sobre el monto (el 4x1000). En un envío, el monto es lo que recibe la persona; en un cobro, lo que envía el pagador.",
  guide_bearer_title: "Quién lo paga",
  guide_bearer_body:
    "El cliente, y se suma a lo que se le cobra como la comisión; o Coloca, y el cliente no ve ningún cambio.",
  guide_scope_title: "Dónde aplica",
  guide_scope_body:
    "Siempre en el país del corredor. Una regla puede cubrir todo el país o solo un riel o una dirección; la más específica gana.",
  guide_own_title: "Tarifa propia",
  guide_own_body:
    "Elige una organización arriba para ver lo que paga. Su tarifa propia gana sobre la general; en 0 % queda exenta.",
  guide_changes_title: "Cambios",
  guide_changes_body:
    "Cada cambio es una versión nueva con fecha; nada se reescribe. Las cotizaciones vigentes conservan el impuesto con el que se calcularon.",
  guide_untaxed_title: "Lo que no paga",
  guide_untaxed_body:
    "Las operaciones en USDT nunca llevan impuestos. Un corredor sin impuestos cobra solo la comisión.",
  banner_general_title: "Impuestos generales",
  banner_general_body:
    "Los paga toda organización sin tarifa propia. Lo que cambies aquí les aplica a todas.",
  banner_general_orgs: "Organizaciones con tarifa propia en algún corredor: {{count}}",
  banner_org_title: "Impuestos de {{name}}",
  banner_org_body: "Lo que paga {{name}}. Lo que cambies aquí le aplica solo a {{name}}.",
  banner_back_to_general: "Ver los generales",
  kpi_all_label: "Corredores",
  kpi_all_meta: "{{taxed}} con impuestos",
  kpi_unavailable: "Sin catálogo de corredores",
  kpi_taxed_label: "Con impuestos",
  kpi_taxed_meta: "Cobran al menos un impuesto",
  kpi_own_label: "Con tarifa propia",
  kpi_own_meta_general: "Alguna organización paga distinto",
  kpi_own_meta_org: "Donde esta organización paga distinto",
  kpi_scheduled_label: "Cambios programados",
  kpi_scheduled_meta: "Una versión empieza más adelante",
  corridors_th_corridor: "Corredor",
  corridors_th_taxes_general: "Impuestos generales",
  corridors_th_taxes_org: "Impuestos de esta organización",
  corridors_th_own: "Tarifa propia",
  corridors_th_client: "Paga el cliente",
  corridors_th_coloca: "Asume Coloca",
  routes_error: "No pudimos cargar los corredores",
  routes_error_detail: "Sin el catálogo de corredores no se puede mostrar qué impuestos cobra cada uno.",
  corridors_empty_title: "No hay corredores",
  corridors_empty_description: "Cuando un corredor tenga ruta aparecerá aquí con sus impuestos.",
  corridors_filtered_empty_title: "Ningún corredor coincide",
  corridors_filtered_empty_description: "Elige otra tarjeta de arriba para ver más corredores.",
  taxes_none: "Sin impuestos",
  commission_unknown: "sin comisión configurada",
  source_general_baseline: "General: {{rate}}",
  source_no_general: "Sin impuesto general",
  own_none: "Ninguna",
  own_count: "Organizaciones: {{count}}",
  own_popover_title: "Organizaciones con tarifa propia",
  own_popover_hint: "Elige una para ver y editar lo que paga.",
  action_edit_taxes: "Editar impuestos",
  action_view_rules: "Ver reglas",
  action_more_aria: "Más acciones de {{corridor}}",
  edit_title_general: "Editar impuestos",
  edit_title_own: "Tarifa propia de {{name}}",
  edit_applies_general: "Aplica a toda organización sin tarifa propia",
  edit_applies_own: "Aplica solo a {{name}}",
  edit_no_taxes_title: "{{country}} no tiene impuestos",
  edit_no_taxes_description:
    "Crea primero el impuesto, por ejemplo el IVA sobre la comisión; después se edita desde cada corredor.",
  edit_tax_label: "Impuesto",
  edit_target_label: "Dónde se guarda el cambio",
  edit_target_broad: "En la regla que sigue este corredor: {{where}} (corredores: {{count}})",
  edit_target_corridor: "Solo en este corredor",
  edit_exempt: "Exenta (0 %)",
  edit_valid_from: "Rige desde el {{date}}",
  edit_collision:
    "Ya hay una versión de esta regla que empieza en ese mismo momento. Elige otra fecha u hora.",
  edit_compare_title: "Hoy vs. con el cambio",
  edit_compare_amount: "Sobre {{amount}}",
  review_intro: "Corredores que cambian: {{count}}. Montos sobre el monto de ejemplo de cada uno.",
  review_orgs_kept: "Estas organizaciones tienen tarifa propia y no cambian ({{count}}):",
  review_orgs_none: "Ninguna organización tiene tarifa propia en estos corredores.",
  remove_title: "Volver a los impuestos generales",
  remove_description:
    "{{name}} deja su tarifa propia en {{corridor}} y paga los impuestos generales desde ahora.",
  remove_broad_note: "Esta tarifa propia cubre varios corredores ({{count}}) y todos vuelven a la general:",
  remove_after_title: "Después del cambio",
  remove_after_none: "Sin impuesto",
  remove_versions_title: "Versiones que se eliminan",
  history_drawer_title: "Historial de {{corridor}}",
  history_drawer_desc_general: "Los cambios de los impuestos generales de este corredor.",
  history_drawer_desc_org: "Los cambios que alcanzan a {{name}} en este corredor: generales y propios.",
  history_empty: "Todavía no hay cambios",
  history_deleted_note: "Las versiones eliminadas como corrección no aparecen aquí.",
  history_role_own: "Propia de {{name}}",
  history_unknown_author: "autor desconocido",
  history_new: "Nueva",
  period_starts: "Empieza el {{from}}",
  period_open: "Desde {{from}}",
  period_range: "{{from}} → {{to}}",
  feed_today: "Hoy",
  feed_yesterday: "Ayer",
  feed_filter_source: "Tipo de regla",
  feed_source_all: "Todas",
  feed_source_general: "Generales",
  feed_source_own: "Propias",
  feed_count: "Cambios: {{count}}",
  feed_empty_title: "Sin cambios",
  feed_empty_description: "Cuando alguien cree o cambie un impuesto aparecerá aquí.",
  feed_load_more: "Ver más",
  toast_scheduled: "{{name}} guardado; rige desde el {{date}}",
  toast_removed: "{{name}} vuelve a los impuestos generales",
};
